exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "h2[data-v-e2ee910e]{font-size:20px}.monitor-table-page__header[data-v-e2ee910e]{display:flex;align-items:center;gap:1rem;padding:0 1rem;border-bottom:1px solid var(--grey-border)}.monitor-table-page__option[data-v-e2ee910e]{margin-bottom:1rem}", ""]);

